import { useState } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import styles from './blog.module.css';
import BlogCardList from './blog-card';
import { BlogProps } from './blog.types';
import NotFoundBlogs from './blog-not-found';
import {
  Container,
  Htag,
  HtagColor,
  HtagVariant,
  Pagination,
  Paragraph,
  SearchButton,
  SearchTextField,
  ServiceCard,
} from '../../components';

export default function BlogPage({ articles, themes, quote }: BlogProps) {
  const { query, pathname, ...router } = useRouter();
  const [isSearch, setIsSearch] = useState<boolean>(false);

  const handleToggleSearch = () => setIsSearch((prev) => !prev);

  const themeSortHandle = (themeId: string) => {
    const { theme, page, search, ...otherQuery } = query;
    if (theme === themeId) {
      router.push({
        pathname,
        query: {
          ...otherQuery,
        },
      });
    } else {
      router.push({
        pathname,
        query: {
          ...otherQuery,
          theme: themeId,
        },
      });
    }
  };

  const pageHandle = ({ selected }: { selected: number }) => {
    const { page, ...otherQuery } = query;

    router.push({
      pathname,
      query: {
        page: selected + 1,
        ...otherQuery,
      },
    });
  };

  return (
    <section className={styles.blog}>
      <Container>
        <Htag
          tag="h3"
          className={styles.blog_title}
          color={HtagColor.light}
          variant={HtagVariant.h3}
        >
          BLOG
        </Htag>
        {quote.text && (
          <Paragraph className={styles.blog_text}>{quote.text}</Paragraph>
        )}

        {isSearch ? (
          <>
            <span className={cn(styles.blog_label, styles.blog_label__search)}>
              Search
            </span>
            <SearchTextField
              handleClose={handleToggleSearch}
              className={styles.blog_search}
            />
            <span className={cn(styles.blog_label, styles.blog_label__result)}>
              Results
            </span>
          </>
        ) : (
          <>
            <span className={cn(styles.blog_label, styles.blog_label__themes)}>
              Themes
            </span>
            <div className={styles.blog_panel}>
              <ul className={styles.list}>
                {themes.map(
                  ({ id, name, svg, count_posts }) =>
                    !!count_posts && (
                      <ServiceCard
                        clickHandle={() => themeSortHandle(String(id))}
                        className={styles.blog_service}
                        title={name}
                        active={String(id) === query.theme}
                        key={id}
                        svg={svg}
                      />
                    ),
                )}
                <li>
                  <SearchButton
                    onClick={handleToggleSearch}
                    className={styles.blog_searchButton}
                  />
                </li>
              </ul>
            </div>
          </>
        )}

        {articles.data.length ? (
          <BlogCardList articles={articles.data} />
        ) : (
          <NotFoundBlogs />
        )}

        {articles.links.lastPage > 1 && (
          <Pagination
            initialPage={Number(query.page) - 1}
            onPageChange={pageHandle}
            pageCount={articles.links.lastPage}
            disableInitialCallback
          />
        )}
      </Container>
    </section>
  );
}
